class Sorting {
    constructor(options) {
        this.options = {};

        this.id = new Date().getUTCMilliseconds() + Math.random();
        this.wrapper = $('<div class="filter-wrapper sorting"/>');
        this.button = $('<button type="button" class="filter sorting"/>')
            .attr('tabindex', 0)
            .attr('aria-label', 'Sortering')
            .attr('aria-controls', 'sorting-' + this.id)
            .attr('aria-owns', 'sorting-' + this.id)
            .on('click', this.onButtonClick.bind(this))
            .appendTo(this.wrapper);

        this.popover = $('<div class="popover hidden"/>')
            .appendTo(this.wrapper);

        this.popoverContent = $('<div class="content"/>')
            .appendTo(this.popover);

        let sortingInput = $('<div class="input"/>').appendTo(this.popoverContent)
            .append($('<label/>').text('Sorteer op'));

        this.sortingInput = $('<select><option value="period">Periode</option><option value="popularity">Populariteit</option><option value="publication">Publicatiedatum</option></select>')
            .appendTo(sortingInput)
            .on('change', this.onChange.bind(this));

        let highlightInput = $('<div class="input"/>').appendTo(this.popoverContent)
            .append($('<label/>').html('Markeer nieuw sinds'));

        this.highlightInput = $('<select><option value="1">Vorig bezoek</option><option value="2">Afgelopen week</option><option value="3">Afgelopen maand</option><option value="4">Afgelopen kwartaal</option></select>')
            .appendTo(highlightInput)
            .on('change', this.onChange.bind(this));

        const sorting = $.fn.cookie('sorting');
        const highlight = $.fn.cookie('highlight');
        if (sorting) {
            this.sortingInput.val(sorting);
            $.fn.cookie('sorting', sorting, { expires : 90 });
        }
        if (highlight) {
            this.highlightInput.val(highlight);
            $.fn.cookie('highlight', highlight, { expires : 90 });
        }

        this.sortingInput.segmentedSelect({ vertical: true });
        this.highlightInput.segmentedSelect({ vertical: true });

        this.options = $.extend(this.options, options);

        this.updateVisibility();
    }
    appendTo(element) {
        this.wrapper.appendTo(element);
        return this;
    }
    insertAfter(element) {
        this.wrapper.insertAfter(element);
        return this;
    }
    updateVisibility() {
        this.button.attr('aria-expanded', this.isVisible ? 'true' : 'false');
        this.popover.attr('aria-hidden', this.isVisible ? 'false' : 'true');
    }
    toggle() {
        if (this.isVisible) this.hide();
        else this.show();
    }
    show() {
        this.wrapper.addClass('visible');
        if (this.hideTimer) clearTimeout(this.hideTimer);
        if (this.showTimer) clearTimeout(this.showTimer);

        if (!this.mouseDownHandler) this.mouseDownHandler = this.onMouseDown.bind(this);
        $(document).on('mousedown', this.mouseDownHandler);

        this.button.addClass('no-radius');
        this.popover.removeClass('hidden');
        this.updateVisibility();

        this.showTimer = setTimeout(function(){
            this.popover.css('max-height', this.popoverContent.height());
        }.bind(this), 10);
    }
    hide() {
        this.wrapper.removeClass('visible');
        if (this.hideTimer) clearTimeout(this.hideTimer);
        if (this.showTimer) clearTimeout(this.showTimer);

        if (this.mouseDownHandler) $(document).off('mousedown', this.mouseDownHandler);

        this.popover.css('max-height', false);
        this.updateVisibility();

        this.hideTimer = setTimeout(function(){
            this.button.removeClass('no-radius');
            this.popover.addClass('hidden');
        }.bind(this), 200);
    }
    reset() {}
    onButtonClick(event) {
        if (event.which === 1) {
            this.toggle();
        }
    }
    onMouseDown(event) {
        if (event.which === 1 && this.isVisible) {
            if (!$.contains(this.wrapper[0], event.target)) this.hide();
        }
    }
    onChange() {
        $.fn.cookie('sorting', this.sortingVal(), { expires : 90 });
        $.fn.cookie('highlight', this.highlightVal(), { expires : 90 });
        if (this.options.onChange) this.options.onChange(this);
    }
    sortingVal() {
        return this.sortingInput.val();
    }
    highlightVal() {
        return this.highlightInput.val();
    }
    get isVisible() {
        return this.wrapper.hasClass('visible');
    }
}
